import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-6 col-12" }
const _hoisted_5 = {
  key: 0,
  class: "col-sm-6 col-12"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { class: "breadcrumb-item active" }

import { useI18n } from 'vue-i18n'
import { useBreadcrumbStore } from '@/store/breadcrumb'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  setup(__props) {

const { t: $t } = useI18n()
const { title, module, page, moduleLink } = storeToRefs(useBreadcrumbStore())

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_unref($t)(_unref(title))), 1)
        ]),
        (_unref(module) !== '' && _unref(page) !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ol", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "iconly-Home icli svg-color" }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_8, [
                  (_unref(moduleLink))
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: _unref(moduleLink)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($t)(_unref(module))), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref($t)(_unref(module))), 1)
                      ], 64))
                ]),
                _createElementVNode("li", _hoisted_9, _toDisplayString(_unref($t)(_unref(page))), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})